module.exports = __webpack_public_path__ + "img/zain-brand-2.94b6636a.png";